<template>
    <div class="app-container">
        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">NQI服务</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/zltszhfw/bzfw' }">标准服务</el-breadcrumb-item>
                    <el-breadcrumb-item>详情</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>

        <el-row class="content" v-if="recid != 'undefined'">
            <h1  style="font-family: 微软雅黑, 宋体">{{detail.jbxx.whsdfbzglTitle}}</h1>
            <el-row class="soure">
                <span style="padding-right: 15px;">发布时间：{{ parseTime(detail.jbxx.whsdfbzglFbtime, '{y}-{m}-{d}') }}</span>
        		<span style="padding-right: 15px;">访问量：{{detail.browseCount}}</span>
        		<span>来源：威海市市场监督管理局</span>
            </el-row>
            <div v-html="detail.jbxx.whsdfbzglContent" class="eidt-content"></div>
        	<el-row class="row" v-if="detail.jbxx.sysAttachments != '' && detail.jbxx.sysAttachments != null">
        	  <el-col  :span="24" align="left">
        	    <div>附件：</div>
        	    <div v-for="(item, index) in detail.jbxx.sysAttachments":key="index" @click="handleDownload(item)" class="down">
        	      <!--{{index+1}} 、--> {{item.fileName}}
        	    </div>
        	  </el-col>
        	</el-row>
        </el-row>
		<el-row class="content" v-else>
		    <h1  style="font-family: 微软雅黑, 宋体">{{detail.jbxx.title}}</h1>
		    <el-row class="soure">
		        <span style="padding-right: 15px;">发布时间：{{ parseTime(detail.jbxx.fbtime, '{y}-{m}-{d}') }}</span>
				<span style="padding-right: 15px;">访问量：{{detail.browseCount}}</span>
				<span>来源：威海市市场监督管理局</span>
		    </el-row>
		    <div v-html="detail.jbxx.content" class="eidt-content"></div>
			<el-row class="row" v-if="detail.jbxx.sysAttachments != '' && detail.jbxx.sysAttachments != null">
			  <el-col  :span="24" align="left">
			    <div>附件：</div>
			    <div v-for="(item, index) in detail.jbxx.sysAttachments":key="index" @click="handleDownload(item)" class="down">
			      <!--{{index+1}} 、--> {{item.fileName}}
			    </div>
			  </el-col>
			</el-row>
		</el-row>

    </div>
</template>

<script>
    import { getZltsWhsdfbzgl } from "@/api/zlts/bzfw/zltsWhsdfbzgl";
	import { getInfo } from "@/api/zlts/bzfw/zltsHggj";
    export default {
        name: "detail",
        data() {
            return {
                // 遮罩层
                loading: true,
                recid:undefined,
                detail:{}
            }
        },
        created() {
			console.log(this.$route.params.recid)
            this.recid = this.$route.params.recid;
			console.log("this.recid===>",this.recid);
			if (this.recid == 'undefined') {
				console.log('111');
			}
			if (this.recid != 'undefined') {
				this.getDetail();
			} else {
				let sess_zltshggj = sessionStorage.getItem("zltshggj");
				let zltshggj = JSON.parse(sess_zltshggj);
				console.log(zltshggj);
				getInfo(zltshggj).then(response => {
				  this.detail = response.data;
				  this.detail.content = this.replaceImgSrc(this.detail.content)
				});
			}
            
        },
        methods: {
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            getDetail(){
                this.loading = true;
                getZltsWhsdfbzgl(this.recid).then(response => {
					// console.log("response.data======",response.data);
                  this.detail = response.data;
                  this.loading = false;
                });
            },
			//下载附件
			handleDownload(file){
			  var name = file.fileName;
			  var url = file.path;
			  const a = document.createElement('a');
			  a.setAttribute('download', name);
			  a.setAttribute('target', '_blank');
			  a.setAttribute('href', process.env.VUE_APP_BASE_API+url);
			  a.click();
			},
        }
    }
</script>

<style scoped>
    .app-container{
        padding:0px 15px 20px;
        background-color: #ffffff;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .content{
        border: 1px solid #cccccc;
        padding:20px 80px;
    }
    .soure{
        background-color:#f3f3f3;
        padding:10px;
        margin: 25px 0;
    }
	.row{
		text-align: left;
		margin-bottom: 1.25rem;
	}
	.down{
	  cursor: pointer;
	  margin-top: 1rem;
	}
	.down:hover{
		color: #2467d2;
	}
	.eidt-content{
		text-align: left;
	}
</style>